export default "__VITE_ASSET__qqcgZI5X__"